import React, {useState, useEffect} from 'react';
import {colorPalette} from '../../../config';
import {Container, HiddenRadio, Label} from './style';
import {BsCheckLg} from 'react-icons/bs';
import {getParticipationCount} from '../../../api/index';
const Radio = ({
	children,
	border,
	name,
	color,
	onChange,
	checked,
	value,
	Icon,
	isDisabled,
}) => {
	let fakeProps = {
		target: {
			name,
			value,
		},
	};
	// const [fullCount, setFullCount] = useState(0);
	// const [halfCount, setHalfCount] = useState(0);
	// const [tenCount, setTenCount] = useState(0);
	// const [fiveCount, setFiveCount] = useState(0);
	// useEffect(() => {
	// 	(async () => {
	// 		let res_full = await getParticipationCount({course: '풀코스'});
	// 		let res_half = await getParticipationCount({course: '하프코스'});
	// 		let res_10 = await getParticipationCount({course: '10km코스'});
	// 		let res_5 = await getParticipationCount({course: '5km코스'});
	// 		setFullCount(res_full.data.count);
	// 		setHalfCount(res_half.data.count);
	// 		setTenCount(res_10.data.count);
	// 		setFiveCount(res_5.data.count);
	// 	})();
	// }, []);
	// if (fullCount > 500) {
	// 	if (fakeProps.target.value == "풀코스") {isDisabled = true}
	// }
	// if (halfCount > 900) {
	// 	if (fakeProps.target.value == "하프코스") {isDisabled = true}
	// }
	// if (tenCount > 3100) {
	// 	if (fakeProps.target.value == "10km코스") {isDisabled = true}
	// }
	// if (fiveCount > 3000) {
	// 	if (fakeProps.target.value == "5km코스") {isDisabled = true}
	// }
	// 코스 비활성화
	// if (fakeProps.target.value == "풀코스") {isDisabled = true}
	// if (fakeProps.target.value == "하프코스") {isDisabled = true}
	// if (fakeProps.target.value == "10km코스") {isDisabled = true}
	// if (fakeProps.target.value == "5km코스") {isDisabled = true}
	return (
		<Container
			onClick={(e) => {
				if (!isDisabled) {
					onChange(fakeProps);
				}
			}}
			isDisabled={isDisabled}
			checked={checked}
			border={border}
		>
			<HiddenRadio
				name={name}
				value={value}
				type='radio'
				onChange={(e) => onChange(e)}
				checked={checked}
				disabled={isDisabled}
			/>
			<Label name={name}>{children}</Label>
			<BsCheckLg
				style={{margin: 'auto 1rem auto auto'}}
				color={
					checked ? colorPalette.secondary : colorPalette.placeholder
				}
			/>
		</Container>
	);
};

export default Radio;
